import MyDepartmentCard from "./myDepartmentCard";
export default MyDepartmentCard;